import http from '../_http'

const loginLog = {
  //user
  summaryUser: (m) => { return http.get(`manager/log/login/user`, m); },
  listUser: (m) => { return http.post(`manager/log/login/user/list`, m); },
  detailUser: (m) => { return http.get(`manager/log/login/user/${m.id}`); },

  //admin
  summaryAdmin: (m) => { return http.get(`manager/log/login/admin`, m); },
  listAdmin: (m) => { return http.post(`manager/log/login/admin/list`, m); },
  detailAdmin: (m) => { return http.get(`manager/log/login/admin/${m.id}`); },

  //partner
  summaryPartner: (m) => { return http.get(`manager/log/login/partner`, m); },
  listPartner: (m) => { return http.post(`manager/log/login/partner/list`, m); },
  detailPartner: (m) => { return http.get(`manager/log/login/partner/${m.id}`); },

  //dashboard
  dashboardLog: (m) => { return http.get(`manager/log/login/dashboard`, m); },
}

export default loginLog

export { loginLog }